module.exports = __webpack_public_path__ + "7e4b29ba/img/dollar-icon.35c9d638.svg";